import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import HomeViewV1 from '../views/HomeViewV1.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/ver1.0',
    name: 'homeV1',
    component: HomeViewV1
  },
  // 사업안내 (사업개요, 브랜드소개, 입지환경, 프리미엄, 오시는길)
  {
    path: '/intro/:sub',
    name: 'intro',
    component: () => import('../views/web/intro/IntroView.vue')
  },
  {
    path: '/location/:sub',
    name: 'location',
    component: () => import('../views/web/location/LocationView.vue')
  },
  // 단지안내 (단지설계, 동호배치도, 커뮤니티)
  {
    path: '/complex/:sub',
    name: 'complex',
    component: () => import('../views/web/product/ProductView.vue')
  },
  // 세대안내 (세대정보, E-모델하우스)
  {
    path: '/space/:sub',
    name: 'space',
    component: () => import('../views/web/type/TypeView.vue')
  },
  // 분양안내 (모집공고, 공급안내)
  {
    path: '/sale/:sub',
    name: 'sale',
    component: () => import('../views/web/product/ProductView.vue')
  },
  // 관심고객등록
  {
    path: '/reservation/register',
    name: 'reservation',
    component: () => import('../views/web/ReservationView.vue')
  },
  {
    path: '/media/:sub',
    name: 'media',
    component: () => import('../views/web/media/VideoView.vue')
  },
  // 상품안내 (기존 호환)
  {
    path: '/product/:sub',
    name: 'product',
    component: () => import('../views/web/product/ProductView.vue')
  },
  // 타입안내 (기존 호환)
  {
    path: '/type/:size',
    name: 'type',
    component: () => import('../views/web/type/TypeView.vue')
  },
  // 개인정보처리방침
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/web/PrivacyView.vue')
  },
  // 모바일 관심고객등록 (랜딩)
  {
    path: '/m/register',
    name: 'mobileRegister',
    component: () => import('../views/MobileRegisterView.vue')
  },
  // 기존 모바일 홈 (이전 버전)
  {
    path: '/last',
    name: 'mobileLast',
    component: () => import('../views/MobileLastView.vue')
  },
  // 관리자
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/admin/AdminView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

// 네이버 로그분석 - SPA 페이지 전환 시 PV 전송
router.afterEach(() => {
  if (window.wcs) {
    if (!window.wcs_add) window.wcs_add = {}
    window.wcs_add['wa'] = 's_40bc4a03dda1'
    window.wcs.inflow()
    window.wcs_do()
  }
})

export default router
